import { cssSpacing, titleSmall, screenMdMax, bodyMediumBold, bodySmall, Text, cssColorValue, } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled, { css } from 'styled-components';
import { TWO_COLUMN_MAX_WIDTH, fadeInAnimation, withAnimationContext, DELAYS, } from '../../../ui';
import { Media } from '../../../ui/Components/Media';
import { mediaLgScreen } from './gridColumns';
import { formatText } from '../../../ui/utils';
export const MediaCaptionWrapper = withAnimationContext(styled.div `
  ${fadeInAnimation(DELAYS.THIRD)};
  grid-column: ${mediaLgScreen};
  display: flex;
  flex-direction: column;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    padding-bottom: ${cssSpacing('looser-5')};
  }
`);
export const MediaWrapper = styled(Media) `
  order: 1;
  display: inline-block;
  padding-bottom: ${cssSpacing('looser')};
  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: ${cssSpacing('looser')};
    order: 2;
  }
`;
const captionColumnStyles = css `
  // not a direct descendent of the parent grid
  // needs to span 5 of the 6 columns given on 12 column grid
  width: calc(5 / 6 * 100%);
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    width: 100%;
  }
`;
export const CaptionHeadline = styled(Text) `
  ${captionColumnStyles}
  ${titleSmall}
  order: 2;
  @media (max-width: ${screenMdMax}) {
    ${bodyMediumBold}
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    ${titleSmall}
    order: 1;
  }
`;
export const CaptionDescription = styled(Text) `
  ${captionColumnStyles}
  ${bodySmall}
  padding-top: ${cssSpacing('base')};
  order: 3;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-top: unset;
  }
  a {
    color: ${cssColorValue('textBase')};
    padding-block: 0 !important;
  }
`;
export const MediaWithCaption = ({ media, captionHeadline, captionDescription, }) => {
    return (React.createElement(MediaCaptionWrapper, null,
        React.createElement(MediaWrapper, { media: media }),
        React.createElement(CaptionHeadline, null, captionHeadline),
        captionDescription && (React.createElement(CaptionDescription, { dangerouslySetInnerHTML: {
                __html: formatText(captionDescription),
            } }))));
};
